import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import AdminHome from './pages/AdminHome';
import CustomerTable from './pages/CustomerTable';
import Cart from './pages/Cart';
import SuperAdminLogin from './pages/SuperAdminLogin';
import SuperAdminHome from './pages/SuperAdminHome';
import CustomerRoom from './pages/CustomerRoom';
import { AuthProvider } from './contexts/AuthContext';
import { SuperAdminProvider } from './contexts/SuperAdminContext';
import './App.css';
import About from './pages/About';
import Contact from './pages/Contact';
import InventoryHome from './pages/InventoryHome';
import MobileHome from './pages/mobile-version/mobileHome';
import ReportsScreen from './pages/mobile-version/reportsScreen';
import AnalyticsScreen from './pages/mobile-version/analaticsScreen';
function App() {
  return (
    <AuthProvider>
      <SuperAdminProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/admin" element={<AdminHome />} />
            <Route path="/admin/inventory" element={<InventoryHome />} />
            <Route path="/table/:restaurantId/:tableId" element={<CustomerTable />} />
            <Route path="/cart" element={<Cart />} />
            
            {/* Super Admin Routes */}
            <Route path="/super-admin/login" element={<SuperAdminLogin />} />
            <Route path="/super-admin/*" element={<SuperAdminHome />} />
            
            {/* Add more routes here as you build out the app */}
            <Route path="/room/:restaurantId/:roomId" element={<CustomerRoom />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mobile" element={<MobileHome />} />
            <Route path="/reportScreen" element={<ReportsScreen/>} />
            <Route path="/analaticsScreen" element={<AnalyticsScreen/>} />
          </Routes>
        </Router>
      </SuperAdminProvider>
    </AuthProvider>
  );
}

export default App;
